export type CurrentTenantStatus = "loading" | "ready" | "none";

export type TenantProductScope = "headless_tms" | "haulbase_agent" | "full_agentic_tms";
export type TenantPortalPath = "/" | "/agent" | "/agentic-tms";

export interface TenantMembershipSummary {
  tenantId: string;
  tenantName: string;
  tenantSlug: string;
  analyticsOptIn: boolean;
  role: "dispatcher" | "manager" | "admin";
  products: readonly TenantProductScope[];
}

export type CurrentTenantState =
  | { status: "loading"; tenantId: null; memberships: [] }
  | { status: "none"; tenantId: null; memberships: [] }
  | {
      status: "ready";
      tenantId: string;
      tenant: TenantMembershipSummary;
      memberships: TenantMembershipSummary[];
    };

export function resolveCurrentTenantState(args: {
  memberships: TenantMembershipSummary[] | null | undefined;
  selectedTenantId?: string | null;
}): CurrentTenantState {
  if (args.memberships === undefined) {
    return { status: "loading", tenantId: null, memberships: [] };
  }

  const memberships = args.memberships ?? [];
  if (memberships.length === 0) {
    return { status: "none", tenantId: null, memberships: [] };
  }

  const selected = args.selectedTenantId
    ? memberships.find((membership) => membership.tenantId === args.selectedTenantId)
    : undefined;
  const tenant = selected ?? memberships[0];

  return {
    status: "ready",
    tenantId: tenant.tenantId,
    tenant,
    memberships,
  };
}

export function hasTenantProduct(
  membership: TenantMembershipSummary,
  product: TenantProductScope,
): boolean {
  return membership.products.includes(product);
}

export function resolveTenantDefaultPath(membership: TenantMembershipSummary): TenantPortalPath {
  if (hasTenantProduct(membership, "full_agentic_tms")) {
    return "/agentic-tms";
  }

  if (hasTenantProduct(membership, "haulbase_agent")) {
    return "/agent";
  }

  return "/";
}
